import { writable } from "svelte/store";
const TWO_MINUTES_MILLIS = 120 * 1000;
function createLastOnlineDatesStore() {
    const store = writable(new Map());
    let storeValue = new Map();
    store.subscribe((v) => (storeValue = v));
    function expired(lastOnline, now) {
        return now - lastOnline.updated > TWO_MINUTES_MILLIS;
    }
    return {
        subscribe: (subscriber, invalidate) => store.subscribe(subscriber, invalidate),
        get: (userId, now) => {
            const value = storeValue.get(userId);
            return value !== undefined && !expired(value, now) ? value : undefined;
        },
        set: (values, now) => {
            store.update((map) => {
                const newMap = new Map();
                for (const [userId, lastOnline] of map) {
                    if (!expired(lastOnline, now)) {
                        newMap.set(userId, lastOnline);
                    }
                }
                for (const [userId, lastOnline] of values) {
                    const current = newMap.get(userId);
                    if (current === undefined || current.lastOnline < lastOnline) {
                        newMap.set(userId, { lastOnline, updated: now });
                    }
                }
                return newMap;
            });
        },
    };
}
export const lastOnlineDates = createLastOnlineDatesStore();
